export const BENEFIT_ICONS = [
  {
    key: "trending-up",
    label: "حاشیه سود",
    paths: (
      <>
        <path d="M3 17l5-5 4 3 6-7M21 8h-4M21 8v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ),
  },
  {
    key: "shield-check",
    label: "تضمین کیفیت",
    paths: (
      <>
        <path d="M12 3l8 4v5c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V7l8-4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ),
  },
  {
    key: "truck",
    label: "ارسال",
    paths: (
      <>
        <path d="M4 7h12v8H4zM16 10h3l2 2v3h-5" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <circle cx="7.5" cy="17" r="1.6" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="17.5" cy="17" r="1.6" stroke="currentColor" strokeWidth="1.6" />
      </>
    ),
  },
  {
    key: "user",
    label: "پشتیبانی",
    paths: (
      <>
        <path d="M12 14c4 0 7 2 7 5H5c0-3 3-5 7-5Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <circle cx="12" cy="8" r="3.4" stroke="currentColor" strokeWidth="1.8" />
      </>
    ),
  },
  {
    key: "monitor",
    label: "بازاریابی",
    paths: (
      <>
        <path d="M4 5h16v11H4zM8 20h8M12 16v4" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M8 11l2.5-3 2 2 3.5-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ),
  },
  {
    key: "gift",
    label: "تخفیف / هدیه",
    paths: (
      <>
        <path d="M12 3v4M12 17v4M3 12h4M17 12h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
      </>
    ),
  },
  {
    key: "star",
    label: "کیفیت برتر",
    paths: (
      <>
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </>
    ),
  },
  {
    key: "globe",
    label: "سراسری",
    paths: (
      <>
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
        <path d="M12 3c-2.5 3-4 5.5-4 9s1.5 6 4 9M12 3c2.5 3 4 5.5 4 9s-1.5 6-4 9M3 12h18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </>
    ),
  },
  {
    key: "award",
    label: "جایزه / رتبه",
    paths: (
      <>
        <circle cx="12" cy="9" r="6" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8.5 15.5L7 21l5-2 5 2-1.5-5.5" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </>
    ),
  },
  {
    key: "leaf",
    label: "طبیعی / ارگانیک",
    paths: (
      <>
        <path d="M6.5 17.5C6.5 17.5 7 10 14 7c4-1.5 7-1 7-1s.5 3-1 7c-2 5-7 7.5-7 7.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.5 17.5c0 0 3-5 7.5-7.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M5 21c1-2 2-3 2-3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </>
    ),
  },
  {
    key: "headphones",
    label: "پشتیبانی تلفنی",
    paths: (
      <>
        <path d="M3 17a9 9 0 0 1 18 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M3 17v2a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-2M16 17v2a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </>
    ),
  },
  {
    key: "package",
    label: "بسته‌بندی",
    paths: (
      <>
        <path d="M12 2l9 5v10l-9 5-9-5V7l9-5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M12 22V12M3.27 6.96L12 12l8.73-5.04" stroke="currentColor" strokeWidth="1.8" />
        <path d="M7.5 4.5l9 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </>
    ),
  },
  {
    key: "chart-bar",
    label: "رشد / آمار",
    paths: (
      <>
        <path d="M3 20h18M8 20V10M12 20V6M16 20v-8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ),
  },
  {
    key: "repeat",
    label: "چرخه / تکرار",
    paths: (
      <>
        <path d="M17 2l4 4-4 4M7 22l-4-4 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3 6h14a4 4 0 0 1 4 4M21 18H7a4 4 0 0 1-4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </>
    ),
  },
  {
    key: "lock",
    label: "امنیت / اعتماد",
    paths: (
      <>
        <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <circle cx="12" cy="16" r="1.2" fill="currentColor" />
      </>
    ),
  },
  {
    key: "zap",
    label: "سرعت / فوری",
    paths: (
      <>
        <path d="M13 2L4 14h8l-1 8 9-12h-8l1-8z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ),
  },
  {
    key: "target",
    label: "هدفمند",
    paths: (
      <>
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="12" r="1.5" fill="currentColor" />
      </>
    ),
  },
  {
    key: "percent",
    label: "تخفیف / درصد",
    paths: (
      <>
        <line x1="19" y1="5" x2="5" y2="19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <circle cx="6.5" cy="6.5" r="2.5" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="17.5" cy="17.5" r="2.5" stroke="currentColor" strokeWidth="1.8" />
      </>
    ),
  },
];

export function BenefitIcon({ iconKey, className = "w-7 h-7" }) {
  const found = BENEFIT_ICONS.find((i) => i.key === iconKey) || BENEFIT_ICONS[0];
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
      {found.paths}
    </svg>
  );
}